export default __webpack_public_path__ + "static/emblem-1f91607c579c8115f67c4d1ab55f065a.svg";